import * as utils from './../libs/user-agent'
import Preload from '../libs/preload-it'
import {MvSwiper} from './mv-swiper'
// import MvSlide from './swiper'
// import anime from 'animejs'


// Preloadをインスタンス化
const preload = new Preload()

// ローディング監視するファイルを追加する。 not で外部リソースを否定しないと、CORS制約で読み込みが停止する。
const $assets = document.querySelectorAll('[src]:not([src*="unpkg.com"]):not([src*="youtube.com"]):not([src*="googletagmanager.com"]):not([src*="google-analytics.com"]):not([src*="google.com"]):not(.wp-embedded-content), [rel="stylesheet"]')
const data     = []
const DOM      = {}
      DOM.html    = document.documentElement
      DOM.loading = document.getElementById('js-loading')
      DOM.bar     = document.getElementById('js-bar')
      DOM.mvSwiper = document.querySelector('.c-mv-swiper')
      console.log(MvSwiper)
// const $num     = document.getElementById( 'js-num' )

Array.prototype.forEach.call($assets, $asset => {
  const url = $asset.src || $asset.href
  if (data.indexOf(url) == -1) {
    data.push($asset.src || $asset.href)
  }
})

preload.fetch(data)

preload.onprogress = event => {
	DOM.bar.style.width = event.progress + '%'
	// $num.textContent = event.progress + '%'
}

// 読み込み完了時のイベント
// 読み込み完了時のイベント
preload.oncomplete = () => {
  if (!DOM.mvSwiper) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        DOM.bar.style.width = '100%'
        DOM.html.classList.add('complete')
        DOM.loading.classList.add('is-complete')
        DOM.loading.classList.add('is-complete')
    
        // setTimeout(() => {
        //   DOM.bar.style.width = '100%'
        //   DOM.html.classList.add('complete')
        //   DOM.loading.classList.add('is-complete')
        // }, 1000)
      })
    })
  
  } else {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          const swiper = new MvSwiper()

          DOM.bar.style.width = '100%'
          DOM.html.classList.add('complete')
          DOM.loading.classList.add('is-complete')
  
          setTimeout(() => {
            swiper.start()
          }, 4000);
        }, 1000)
      })
    })
  }


  // requestAnimationFrame(() => {
	// 	requestAnimationFrame(() => {
      
  //     DOM.bar.style.width = '100%'
	// 		DOM.html.classList.add('complete')
	// 		DOM.loading.classList.add('is-complete')
  //     DOM.loading.classList.add('is-complete')
  //       // console.log(DOM.loading.classList.contains('is-complete'))
	// 	})
	// })

}
